import type {TabGroup} from 'src/features/erp/components/erp-tab-pages/types';
import type {Document} from 'src/typings';
import {RECORD_DETAIL_DETAILS_TAB} from 'src/features/erp-sutor/features/generic-record-detail';
import {exists} from 'shared/utils/custom-utils';
import EmployeeRecordDetailTab from './EmployeeRecordDetailTab.svelte';
import SutorUserAccountAttendanceTab
    from 'src/features/user/kp-user-account-page/sutor-parts/tab-pages/SutorUserAccountAttendanceTab.svelte';

export function modifyTabGroupsForUserRecord(currentTabGroups: TabGroup[], userRecord: Document): TabGroup[] {
    const tabDetail = currentTabGroups.find((group) => group.id === RECORD_DETAIL_DETAILS_TAB);
    if (exists(tabDetail)) {
        tabDetail.render = {
            component: EmployeeRecordDetailTab,
            padded: true
        };
    }

    currentTabGroups.push({
        id: 'tab-attendance',
        label: 'Docházka',
        icon: 'calendar',
        render: {
            component: SutorUserAccountAttendanceTab,
            props: {
                injectedUserRecord: userRecord
            },
            padded: true
        }
    });

    return currentTabGroups;
}